export const CHANGED_GAME_FOR_DISCOVER_PAGE = 'CHANGED_GAME_FOR_DISCOVER_PAGE'
export const STARTED_FETCHING_GUIDES_BY_GAME = 'STARTED_FETCHING_GUIDES_BY_GAME'
export const FINISHED_FETCHING_GUIDES_BY_GAME = 'FINISHED_FETCHING_GUIDES_BY_GAME'